export { CorporativoOnboardingTutorialEasy } from "./CorporativoOnboardingTutorialEasy";
